import { createFieldBase, FieldBase, FieldBaseArguments } from './FieldBase';

export function createEntityPickerField({
  value,
  ...options
}: EntityPickerFieldArguments): EntityPickerField {
  const fieldBase = createFieldBase(options);

  let self: EntityPickerField = {
    ...fieldBase,
    value,
    componentType: 'entity-picker',
  };

  return self;
}

// TYPES:
export interface EntityPickerFieldArguments extends FieldBaseArguments {
  value?: string | number | boolean;
}

export interface EntityPickerField extends FieldBase {
  componentType: string
  value?: string | number | boolean;
}



// WEBPACK FOOTER //
// ./app/insa-components/insa-generic-form/generic-editor/models/Field/EntityPickerField.ts